import React from 'react';
import {useHistory} from "react-router-dom";
import {Box, Button, Grid, Link, Paper} from '@material-ui/core';

import {formatDate} from "../../../helpers/dateHelpers";
import {guestAcquisitionLatestOfferUrl, Routers} from '../../../config/constants';
import {useRequiredEmptyAttributes, useRestaurantId} from "../../../selectors/RestaurantSelectors";
import {GuestAcquisition} from '../../../entities';
import ConfirmationModal from "./ConfirmationModal";


export function Offer() {
  const {
    useLatestOffer,
    useRestaurantSettings,
    isOfferAccepted,
    useAcceptOfferMutation,
    matchRestaurantOffer,
  } = GuestAcquisition;
  const latestOffer = useLatestOffer();
  const acceptOfferMutation = useAcceptOfferMutation();
  const restaurantId = useRestaurantId();
  const restaurantSettingsResult = useRestaurantSettings();
  const requiredEmptyAttributes = useRequiredEmptyAttributes();
  const isLatestOfferAccepted = isOfferAccepted(latestOffer, restaurantSettingsResult.data);
  const acceptedOffer = matchRestaurantOffer(latestOffer, restaurantSettingsResult.data);
  const history = useHistory();

  const [isOpenConfirmation, setIsOpenConfirmation] = React.useState(false);

  const openConfirmation = () => {
    setIsOpenConfirmation(true);
  };

  const closeConfirmation = () => {
    setIsOpenConfirmation(false);
  };

  const onAcceptOffer = () => {
    if (acceptOfferMutation.isLoading) {
      return;
    }

    acceptOfferMutation.mutate({restaurantId});
    closeConfirmation();
  }

  const goToSettings = () => {
    history.push(Routers.about);
  }

  if (!latestOffer || !restaurantSettingsResult.data) {
    return null;
  }

  let OfferComponent = null;
  if (isLatestOfferAccepted) {
    OfferComponent = (
      <Grid item xs={12} md={8}>
        <Paper elevation={3}>
          <Box p={2} style={{color: 'rgba(140, 140, 150, 1)'}}>
            Оферта от {formatDate(acceptedOffer.publishDate)}{' '}
            принята {formatDate(acceptedOffer.acceptedDate)}.{' '}
            <Link
              href={guestAcquisitionLatestOfferUrl}
              target="_blank"
              rel="noreferrer"
              color="inherit"
              underline="always"
            >Посмотреть оферту</Link>
          </Box>
        </Paper>
      </Grid>
    );
  } else {
    OfferComponent = (
      <Grid item xs={12} md={8}>
        {isOpenConfirmation && (
          <ConfirmationModal
            handleClose={closeConfirmation}
            handleAccept={onAcceptOffer}
          />
        )}
        <Paper elevation={3} style={{backgroundColor: '#FFEE8F'}}>
          <Box
            p={2}
            display="flex"
            flexWrap={{xs: 'wrap', sm: 'nowrap'}}
          >
            <Box flexGrow={1} mb={{xs: 1, sm: 0}} pr={2}>
              Вы ещё не приняли условия{' '}
              <Link
                href={guestAcquisitionLatestOfferUrl}
                target="_blank"
                rel="noreferrer"
                style={{color: 'rgba(37, 80, 255, 1)'}}
              >Публичной оферты</Link>{' '}
              на&nbsp;заключение смешанного договора.
              Это необходимо для&nbsp;подключения сервисов привлечения гостей
            </Box>
            <Box flexShrink={0}>
              <Button
                variant="outlined"
                style={{backgroundColor: 'white'}}
                onClick={openConfirmation}
              >Принять оферту&hellip;</Button>
            </Box>
          </Box>
        </Paper>
      </Grid>
    );
  }

  let RequiredComponent = null;
  if (requiredEmptyAttributes.length > 0) {
    if (restaurantSettingsResult.data.channels.length > 0) {
      RequiredComponent = (
        <Grid item xs={12} md={8}>
          <Paper elevation={3} style={{backgroundColor: '#FFEE8F'}}>
            <Box
              p={2}
              display="flex"
              flexWrap={{xs: 'wrap', sm: 'nowrap'}}
            >
              <Box>
                Некоторые данные о&nbsp;ресторане не&nbsp;заполнены.
                Привлечение гостей приостановлено.{' '}
                <Link
                  href="/about"
                  color="inherit"
                  onClick={(event) => {
                    event.preventDefault();
                    goToSettings();
                  }}
                  style={{color: 'rgba(37, 80, 255, 1)'}}
                >Восстановите данные</Link>{', '}
                чтобы сервис снова стал доступен
              </Box>
            </Box>
          </Paper>
        </Grid>
      );
    } else {
      RequiredComponent = (
        <Grid item xs={12} md={8}>
          <Paper elevation={3} style={{backgroundColor: '#FFEE8F'}}>
            <Box
              p={2}
              display="flex"
              flexWrap={{xs: 'wrap', sm: 'nowrap'}}
            >
              <Box>
                Чтобы начать привлекать гостей, заполните обязательные
                поля в&nbsp;разделе &laquo;
                <Link
                  href="/about"
                  onClick={(event) => {
                    event.preventDefault();
                    goToSettings();
                  }}
                  style={{color: 'rgba(37, 80, 255, 1)'}}
                >О&nbsp;ресторане</Link>
                &raquo; (меню &laquo;Настройки&raquo;)
              </Box>
            </Box>
          </Paper>
        </Grid>
      );
    }
  }

  return (
    <>
      {OfferComponent}
      {RequiredComponent}
    </>
  );
}
